import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "player player-a" }
const _hoisted_2 = {
  key: 0,
  class: "h5"
}
const _hoisted_3 = {
  key: 1,
  class: "fst-italic"
}
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { class: "player player-b" }
const _hoisted_6 = {
  key: 0,
  class: "h5"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 2,
  class: "fst-italic"
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 2,
  class: "rewind-controls"
}
const _hoisted_11 = {
  key: 3,
  class: "rewind-controls"
}
const _hoisted_12 = ["disabled"]

import GameView from '../../../shared/pixi-board/GameView.js';
import { onMounted, onUnmounted, ref, Ref, PropType, toRefs } from 'vue';
import { BIconCheck, BIconChevronBarLeft, BIconChevronBarRight, BIconChevronLeft, BIconChevronRight, BIconCrosshair, BIconScissors, BIconTrophyFill, BIconX } from 'bootstrap-icons-vue';
import GameFinishedOverlay from './overlay/GameFinishedOverlay.vue';
import { defineOverlay } from '@overlastic/vue';
import AppChrono from './AppChrono.vue';
import AppPseudo from './AppPseudo.vue';
import { Player } from '../../../shared/app/models/index.js';
import TimeControlType from '../../../shared/time-control/TimeControlType.js';
import { GameTimeData } from '../../../shared/time-control/TimeControl.js';
import useConditionalMovesStore from '../../stores/conditionalMovesStore.js';
import { storeToRefs } from 'pinia';


export default /*@__PURE__*/_defineComponent({
  __name: 'AppBoard',
  props: {
    players: {
        type: Array as PropType<(null | Player)[]>,
        required: true,
    },
    timeControlOptions: {
        type: Object as PropType<TimeControlType>,
        required: false,
        default: null,
    },
    timeControlValues: {
        type: Object as PropType<GameTimeData>,
        required: false,
        default: null,
    },
    gameView: {
        type: GameView,
        required: true,
    },
},
  setup(__props) {

/* eslint-env browser */
const pixiApp = ref<HTMLElement>();

const props = __props;

const { gameView } = props;
const { players, timeControlOptions, timeControlValues } = toRefs(props);

/*
 * Add piwi view
 */
const game = gameView.getGame();

onMounted(() => {
    if (!pixiApp.value) {
        throw new Error('No element with ref="pixiApp"');
    }

    gameView.mount(pixiApp.value);
});

onUnmounted(() => {
    gameView.destroy();
});

/*
 * Orientation auto update on screen size change
 */
let orientation = ref<number>(gameView.getCurrentOrientation());

const updateOrientation = () => orientation.value = gameView.getCurrentOrientation();

gameView.on('orientationChanged', updateOrientation);

onUnmounted(() => {
    gameView.off('orientationChanged', updateOrientation);
});

/*
 * Game end: win popin
 */
const gameFinishedOverlay = defineOverlay(GameFinishedOverlay);

gameView.on('endedAndWinAnimationOver', () => {
    gameFinishedOverlay({
        game,
        players: players.value as Player[],
    });
});

onUnmounted(() => gameView.removeAllListeners('endedAndWinAnimationOver'));

/*
 * Rewind
 */
gameView.listenArrowKeys();

const hasRewindControls = ref(false);

const btnRewindBack = ref<HTMLElement>();
const btnRewindForward = ref<HTMLElement>();

const blinkButton = (button: Ref<HTMLElement | undefined>) => {
    button.value?.classList.add('active');
    setTimeout(() => button.value?.classList.remove('active'), 80);
};

gameView.on('movesHistoryCursorChanged', cursor => hasRewindControls.value = null !== cursor);

const rewindZero = () => gameView.setMovesHistoryCursor(-1);
const backward = () => gameView.changeMovesHistoryCursor(-1);
const forward = () => gameView.changeMovesHistoryCursor(+1);
const rewindCurrent = () => gameView.setMovesHistoryCursor(Infinity);
const rewindClose = () => {
    gameView.disableRewindMode();
};

const keyboardEventListener = (event: KeyboardEvent) => {
    if ((event.target as HTMLElement | null)?.nodeName === 'INPUT')
        return;
    switch (event.key) {
        case 'ArrowLeft':
            blinkButton(btnRewindBack);
            break;

        case 'ArrowRight':
            blinkButton(btnRewindForward);
            break;
    }
};

window.addEventListener('keydown', keyboardEventListener);

onUnmounted(() => {
    window.removeEventListener('keydown', keyboardEventListener);
});

/*
 * Conditional moves
 */
const { conditionalMovesEditor } = storeToRefs(useConditionalMovesStore());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["app-board", { 'has-rewind-controls': hasRewindControls.value || _unref(conditionalMovesEditor)?.getIsSimulationMode() }])
  }, [
    _createElementVNode("div", {
      class: "board-container",
      ref_key: "pixiApp",
      ref: pixiApp
    }, null, 512),
    (_unref(game))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(['game-info-overlay', `orientation-${_unref(orientation)}`])
        }, [
          _createElementVNode("div", _hoisted_1, [
            (_unref(players))
              ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
                  (_unref(players)[0])
                    ? (_openBlock(), _createBlock(AppPseudo, {
                        key: 0,
                        rating: "",
                        onlineStatus: "",
                        player: _unref(players)[0],
                        classes: "text-danger"
                      }, null, 8, ["player"]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$t('waiting')), 1)),
                  (_unref(game).getWinner() === 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                        _cache[10] || (_cache[10] = _createTextVNode(" ")),
                        _createVNode(_unref(BIconTrophyFill), { class: "text-warning" })
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_unref(timeControlOptions) && _unref(timeControlValues))
              ? (_openBlock(), _createBlock(AppChrono, {
                  key: 1,
                  timeControlOptions: _unref(timeControlOptions),
                  playerTimeData: _unref(timeControlValues).players[0]
                }, null, 8, ["timeControlOptions", "playerTimeData"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_unref(players))
              ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
                  (_unref(game).getWinner() === 1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                        _createVNode(_unref(BIconTrophyFill), { class: "text-warning" }),
                        _cache[11] || (_cache[11] = _createTextVNode(" "))
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(players)[1])
                    ? (_openBlock(), _createBlock(AppPseudo, {
                        key: 1,
                        rating: "",
                        onlineStatus: "",
                        player: _unref(players)[1],
                        classes: "text-primary"
                      }, null, 8, ["player"]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.$t('waiting')), 1))
                ]))
              : _createCommentVNode("", true),
            (_unref(timeControlOptions) && _unref(timeControlValues))
              ? (_openBlock(), _createBlock(AppChrono, {
                  key: 1,
                  timeControlOptions: _unref(timeControlOptions),
                  playerTimeData: _unref(timeControlValues).players[1]
                }, null, 8, ["timeControlOptions", "playerTimeData"]))
              : _createCommentVNode("", true)
          ])
        ], 2))
      : (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.$t('initializing_game')), 1)),
    (hasRewindControls.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (rewindZero())),
            class: "btn btn-outline-primary"
          }, [
            _createVNode(_unref(BIconChevronBarLeft))
          ]),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (backward())),
            class: "btn btn-outline-primary",
            ref_key: "btnRewindBack",
            ref: btnRewindBack
          }, [
            _createVNode(_unref(BIconChevronLeft))
          ], 512),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (forward())),
            class: "btn btn-outline-primary",
            ref_key: "btnRewindForward",
            ref: btnRewindForward
          }, [
            _createVNode(_unref(BIconChevronRight))
          ], 512),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (rewindCurrent())),
            class: "btn btn-outline-primary"
          }, [
            _createVNode(_unref(BIconChevronBarRight))
          ]),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (rewindClose())),
            class: "btn btn-outline-danger"
          }, [
            _createVNode(_unref(BIconX))
          ])
        ]))
      : (_unref(conditionalMovesEditor)?.getIsSimulationMode())
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(conditionalMovesEditor).startNewLine())),
              class: "btn btn-outline-primary"
            }, [
              _createVNode(_unref(BIconCrosshair))
            ]),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(conditionalMovesEditor).back())),
              class: "btn btn-outline-primary"
            }, [
              _createVNode(_unref(BIconChevronLeft))
            ]),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(conditionalMovesEditor).cutMove())),
              class: "btn btn-outline-danger",
              disabled: 0 === _unref(conditionalMovesEditor).getSelectedLine().length
            }, [
              _createVNode(_unref(BIconScissors))
            ], 8, _hoisted_12),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_unref(conditionalMovesEditor).submitConditionalMoves())),
              class: _normalizeClass(["btn", _unref(conditionalMovesEditor).getHasChanges() ? 'btn-success' : 'btn-outline-success'])
            }, [
              _createVNode(_unref(BIconCheck)),
              _cache[12] || (_cache[12] = _createTextVNode(" Save "))
            ], 2),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[9] || (_cache[9] = ($event: any) => {_unref(conditionalMovesEditor).discardSimulationMoves(); _unref(gameView)!.disableSimulationMode()}),
              class: "btn btn-outline-warning"
            }, [
              _createVNode(_unref(BIconX))
            ])
          ]))
        : _createCommentVNode("", true)
  ], 2))
}
}

})